export default "__VITE_ASSET__d95a2704__"